import { TagType } from '../TagType';

export const ACL_TAG = { type: TagType.Acl, id: 'LIST' };
export const TAG_CURRENT_STAGE = { type: TagType.Ticket, id: 'CURRENT_STAGE' };
export const TAG_BY_ACTIVITY_LOG = { type: TagType.Ticket, id: 'ACTIVITY_LOG' };
export const TAG_BY_TICKET_SUMMARY = {
  type: TagType.Ticket,
  id: 'TICKET_SUMMARY',
};
export const TAG_CURRENT_VERSION = {
  type: TagType.Ticket,
  id: 'CURRENT_VERSION',
};
export const TURN_TRACKING_TAG = { type: TagType.TurnTracking, id: 'LIST' };
export const TAG_CLAUSES = { type: TagType.Document, id: 'CLAUSES' };
export const TAG_WORKFLOWS_BY_LIST = { type: TagType.Workflows, id: 'LIST' };
export const TAG_ROUTINGS_BY_LIST = { type: TagType.Routings, id: 'LIST' };
export const TAG_ROUTING_CONFIGURATION = {
  type: TagType.Routings,
  id: 'CONFIG',
};
